export const OA_OBJECTS = [
  {
    name: "noval",
    display: "--- Select --- ",
    commonFields: [],
    dropdownFields: [],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: true,
  },
  {
    name: "ApprovalLine",
    display: "Approval Line",
    commonFields: [
      "timesheetid",
      "invoiceid",
      "envelopeid",
      "userid",
      "approvalprocessid",
      "action",
      "date",
      "pending_done",
    ],
    dropdownFields: ["userid", "customerid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Attachment",
    display: "Attachment",
    commonFields: [],
    dropdownFields: [],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Attribute",
    display: "Attribute",
    commonFields: [],
    dropdownFields: ["attribute_setid"],
    referenceFields: ["attributeid"],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "AttributeDescription",
    display: "Attribute Description",
    commonFields: [],
    dropdownFields: ["attributeid", "resourcepfoile_typeid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Attributeset",
    display: "Attribute Set",
    commonFields: [],
    dropdownFields: [],
    referenceFields: ["attribute_setid"],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Projectbillingrule",
    display: "Billing Rule",
    commonFields: [
      "name",
      "cap_hours",
      "percent",
      "slip_stageid",
      "cap",
      "active",
      "description",
      "categoryid",
      "type",
      "rate_from",
      "position",
      "rate_cardid",
      "start_date",
      "end_date",
      "projectid",
      "amount",
      "customerid",
    ],
    dropdownFields: ["slip_stageid", "categoryid", "rate_cardid", "customerid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Booking",
    display: "Booking",
    commonFields: [
      "hours",
      "userid",
      "startdate",
      "percentage",
      "projectid",
      "booking_typeid",
      "project_taskid",
      "enddate",
    ],
    dropdownFields: ["userid", "booking_typeid", "customerid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "BookingByDay",
    display: "Booking By Day",
    commonFields: [
      "date",
      "userid",
      "customer_id",
      "project_id",
      "booking_type_id",
      "hours",
    ],
    dropdownFields: ["userid", "customer_id", "booking_type_id"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "BookingType",
    display: "Booking Type",
    commonFields: ["name", "active"],
    dropdownFields: [],
    referenceFields: ["booking_typeid", "booking_type_id"],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Slip",
    display: "Charge",
    commonFields: [
      "date",
      "rate",
      "slip_stageid",
      "cost",
      "total",
      "categoryid",
      "customerid",
      "type",
      "userid",
      "invoiceid",
      "currency",
      "decimal_hours",
      "itemid",
      "quantity",
      "projectid",
      "projecttaskid",
    ],
    dropdownFields: ["slip_stageid", "userid", "categoryid", "customerid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Slipstage",
    display: "Charge Stage",
    commonFields: ["nickname"],
    dropdownFields: [],
    referenceFields: ["slip_stageid"],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Company",
    display: "Company",
    commonFields: ["name"],
    dropdownFields: [],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Contact",
    display: "Contact",
    commonFields: ["name", "active", "customerid"],
    dropdownFields: ["customerid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "CustField",
    display: "Custom Fields",
    commonFields: ["name"],
    dropdownFields: ["userid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Customer",
    display: "Customer",
    commonFields: ["name", "company", "active"],
    dropdownFields: ["userid"],
    referenceFields: ["customerid", "customer_id"],
    deleteAvailable: true,
    mergeable: true,
  },
  {
    name: "Customerpo_to_project",
    display: "Customer PO to Project",
    commonFields: ["customerpoid"],
    dropdownFields: ["customerid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Department",
    display: "Department",
    commonFields: ["name"],
    dropdownFields: [],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "ExpensePolicyItem",
    display: "Expense Policy Item",
    commonFields: [],
    dropdownFields: [],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Envelope",
    display: "Expense Report",
    commonFields: ["userid", "date", "customerid"],
    dropdownFields: ["userid"],
    referenceFields: ["envelopeid"],
    deleteAvailable: true,
    mergeable: true,
  },
  {
    name: "Item",
    display: "Expense Item",
    commonFields: ["name"],
    dropdownFields: [],
    referenceFields: ["itemid"],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "ImportExport",
    display: "Import/Export",
    commonFields: ["type", "association"],
    dropdownFields: [],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Invoice",
    display: "Invoice",
    commonFields: [
      "customerid",
      "number",
      "status",
      "date",
      "emailed",
      "balance",
    ],
    dropdownFields: ["customerid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: true,
  },
  {
    name: "Issue",
    display: "Issue",
    commonFields: ["number", "name", "project_id"],
    dropdownFields: [
      "user_id",
      "customer_id",
      "iss_code_reviewer__c",
      "iss_proj_owner__c",
      "iss_tester__c",
      "sr_developer__c",
      "owner_id",
      "issue_stage_id",
      "issue_severity_id",
      "issue_category_id",
      "issue_source_id",
      "issue_status_id",
    ],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "IssueCategory",
    display: "Issue Category",
    commonFields: ["name", "active"],
    dropdownFields: [],
    referenceFields: ["issue_category_id"],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "IssueSeverity",
    display: "Issue Severity",
    commonFields: ["name", "active"],
    dropdownFields: [],
    referenceFields: ["issue_severity_id"],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "IssueSource",
    display: "Issue Source",
    commonFields: ["name", "active"],
    dropdownFields: [],
    referenceFields: ["issue_source_id"],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "IssueStage",
    display: "Issue Stage",
    commonFields: ["name"],
    dropdownFields: [],
    referenceFields: ["issue_stage_id"],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "IssueStatus",
    display: "Issue Status",
    commonFields: ["name", "active"],
    dropdownFields: [],
    referenceFields: ["issue_status_id"],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Jobcode",
    display: "Job Code",
    commonFields: ["name", "active"],
    dropdownFields: [],
    referenceFields: ["jobcodeid", "job_codeid", "jobcode_id", "job_code_id"],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "LoadedCost",
    display: "Loaded Cost",
    commonFields: ["userid", "end", "current", "cost", "start", "lc_level"],
    dropdownFields: ["userid", "customerid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Preference",
    display: "Preference",
    commonFields: [],
    dropdownFields: ["userid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Project",
    display: "Project",
    commonFields: [
      "active",
      "name",
      "project_stageid",
      "customer_name",
      "userid",
    ],
    dropdownFields: ["userid", "rate_cardid", "customerid"],
    referenceFields: ["projectid"],
    deleteAvailable: true,
    mergeable: true,
  },
  {
    name: "Projectassign",
    display: "Project Assignment",
    commonFields: ["project_id", "userid"],
    dropdownFields: ["user_id", "customer_id"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: true,
  },
  {
    name: "Projectbillingtransaction",
    display: "Project Billing Transaction",
    commonFields: [
      "projectid",
      "customerid",
      "project_taskid",
      "slipid",
      "taskid",
      "total",
      "date",
      "userid",
    ],
    dropdownFields: ["categoryid", "userid", "customerid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "ProjectBudgetGroup",
    display: "Project Budget Group",
    commonFields: ["name", "customerid", "projectid", "date", "total"],
    dropdownFields: ["customerid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Ratecard",
    display: "Rate Card",
    commonFields: ["name", "active"],
    dropdownFields: [],
    referenceFields: ["rate_cardid"],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Ticket",
    display: "Receipt",
    commonFields: ["userid"],
    dropdownFields: ["userid", "customerid", "categoryid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Report",
    display: "Report",
    commonFields: ["name", "userid"],
    dropdownFields: ["userid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Resourceprofile",
    display: "Resource Profile",
    commonFields: [],
    dropdownFields: ["userid", "resourceprofile_typeid", "attributeid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Resourceprofile_type",
    display: "Resource Profile Type",
    commonFields: [],
    dropdownFields: ["userid"],
    referenceFields: ["resourceprofile_typeid"],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Revenue_recognition_rule",
    display: "Revenue Rule",
    commonFields: [],
    dropdownFields: ["customerid", "categoryid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Revenue_recognition_rule_amount",
    display: "Revenue Rule Amount",
    commonFields: ["revenue_recognition_rule_id"],
    dropdownFields: ["category_id"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Revenue_recognition_transaction",
    display: "Revenue Transaction",
    commonFields: [],
    dropdownFields: ["userid", "categoryid", "customerid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Schedulebyday",
    display: "Schedule By Day",
    commonFields: ["userid"],
    dropdownFields: ["userid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Schedulerequest",
    display: "Schedule Request",
    commonFields: ["userid"],
    dropdownFields: ["userid", "customerid", "categoryid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Schedulerequest_item",
    display: "Schedule Request Item",
    commonFields: ["userid"],
    dropdownFields: ["userid", "customerid", "categoryid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Category",
    display: "Service",
    commonFields: ["name", "active"],
    dropdownFields: [],
    referenceFields: ["categoryid", "default_categoryid", "category_id"],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Projecttask",
    display: "Task",
    commonFields: ["name", "is_a_phase", "projectid"],
    dropdownFields: ["customerid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: true,
  },
  {
    name: "Projecttaskassign",
    display: "Task Assignment",
    commonFields: ["projectaskid", "userid", "projectid"],
    dropdownFields: ["customerid", "userid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Task",
    display: "Time Entry",
    commonFields: [
      "userid",
      "date",
      "decimal_hours",
      "projectid",
      "projecttaskid",
      "timesheetid",
      "customerid",
    ],
    dropdownFields: ["userid", "categoryid", "customerid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Timesheet",
    display: "Timesheet",
    commonFields: ["userid", "starts", "ends", "status", "total"],
    dropdownFields: ["userid", "default_categoryid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: true,
  },
  {
    name: "User",
    display: "User",
    commonFields: [
      "departmentid",
      "name",
      "job_codeid",
      "role_id",
      "active",
      "nickname",
      "line_managerid",
    ],
    dropdownFields: [],
    referenceFields: [
      "userid",
      "user_id",
      "iss_code_reviewer__c",
      "iss_proj_owner__c",
      "iss_tester__c",
      "sr_developer__c",
      "owner_id",
    ],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "UserWorkschedule",
    display: "Workschedule",
    commonFields: ["name", "userid"],
    dropdownFields: ["userid"],
    referenceFields: [],
    deleteAvailable: true,
    mergeable: false,
  },
  {
    name: "Workspace",
    display: "Workspace",
    commonFields: ["name"],
    dropdownFields: ["userid"],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
  {
    name: "Workspacelink",
    display: "Workspace Link",
    commonFields: ["recordid"],
    dropdownFields: [],
    referenceFields: [],
    deleteAvailable: false,
    mergeable: false,
  },
];

export const NUMERIC_FIELDS = [
  "id",
  "percentage",
  "hours",
  "total",
  "decimal_hours",
  "cost",
  "quantity",
  "rate",
];

export const DATE_FIELDS = [
  "enddate",
  "startdate",
  "date",
  "starts",
  "ends",
  "acct_date",
  "fnlt_date",
  "start_date",
  "iss_estimated_date__c",
  "date_resolution_required",
  "date_resolution_expected",
  "date_resolved",
  "approved",
  "submitted",
];

export const DATETIME_FIELDS = ["created", "updated"];
